import React from 'react';

export function CircleCheckIcon() {
  // https://lucide.dev/icons/circle-check
  return (
    <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="m9 12 2 2 4-4" />
    </g>
  );
}
